<template>
  <div
    class="restriction-banner bg-negative rotate-315 absolute-top-left text-uppercase"
    :class="$getTextColor(currentSite, 'negative')"
    data-test-id="age-restricted-banner"
  >
    {{ $t('acknowledgment.ageRestricted') }}
  </div>
</template>

<script>
export default {
  name: 'AgeRestrictedBanner',
  configuration: ['currentSite']
}
</script>
<style lang="scss" scoped>
.restriction-banner {
    font-size: 9px;
    line-height: 1;
    padding: 5px 30px !important;
    text-align: center;
    margin-left: -40px;
    margin-top: 5px;
    word-break: break-word;
    width: 120px;
    z-index: 1;
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    box-sizing: border-box;         /* Opera/IE 8+ */
}

</style>
